import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { products } from "../data/products";
import {
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  Dialog,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function CategoryDetail() {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const category = products[categoryId];

  const [selectedImage, setSelectedImage] = useState(null);

  if (!category) {
    return <Typography>Kategori bulunamadı.</Typography>;
  }

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  return (
    <Container sx={{ py: 4 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: 8,
        }}
      >
        <IconButton onClick={() => navigate("/")} size="large">
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" component="h1">
          {category.title}
        </Typography>
      </div>
      <Grid container spacing={3}>
        {category.items.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card>
              <CardMedia
                component="img"
                height="400"
                src={item.image}
                alt={item.name}
                onClick={() => handleImageClick(item.image)}
                style={{ cursor: "pointer" }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={!!selectedImage} onClose={() => setSelectedImage(null)}>
        <img
          src={selectedImage}
          alt="Büyütülmüş Resim"
          style={{ maxWidth: "90vw", maxHeight: "90vh", cursor: "pointer" }}
          onClick={() => setSelectedImage(null)}
        />
      </Dialog>
    </Container>
  );
}

export default CategoryDetail;
